import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { BankDetails, BankDetailsClient, Kasa, KasaClient} from "src/app/web-api-client";
import { WtStorageService } from "../../wt-storage.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DateHelper } from "src/app/shared/helpers/date.helper";
import { BankAccountAddComponent } from "./bank-account-add/bank-account-add.component";
import { BankAccountEditComponent } from "./bank-account-edit/bank-account-edit.component";
import { ToastrService } from "ngx-toastr";


@Component({
  selector: 'app-bank-account',
  templateUrl: './bank-account.component.html',
  styleUrls: ['./bank-account.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class BankAccountComponent implements OnInit {

  public isLoaded: boolean = false;
  selectedService: BankDetails;
  public services: BankDetails[];


  constructor(
    private readonly changeDetectionRef: ChangeDetectorRef,
    public readonly localCache: WtStorageService,
    private readonly modalService: NgbModal,
    public client: BankDetailsClient,
    private readonly toastr: ToastrService
  ) {

  }

  ngOnInit(): void {

    this.LoadData();

  }


  private LoadData() {
    this.client.getList().subscribe((allServices: BankDetails[]) => {
            this.services = allServices;
            this.isLoaded = true;
            this.changeDetectionRef.detectChanges();
        });
    }

  public onSelected(service: BankDetails){
   if (this.isSelected(service)){
    this.selectedService = null;
  }
  else{

     this.selectedService = service;
  }
 }

  public isSelected(service: BankDetails):boolean{
   return this.selectedService == service;
 }

  public onUpdate():void{

    let modalRef = this.modalService.open(BankAccountEditComponent);
    modalRef.componentInstance.selectedService = this.selectedService;
    modalRef.componentInstance.onClose.subscribe(r => {

      this.LoadData();
    });
  }

  public onAdd(): void {

    let modalRef = this.modalService.open(BankAccountAddComponent);
    modalRef.componentInstance.onClose().subscribe(r => {

      this.LoadData();
    });

  }

  public GetBankType(status: number) {

    switch (status) {
      case 0:
        return "Стандартна"
      case 1:
        return "Бюджетна"
      default:
        return "Не дефинирана"
    }
  }

  public onImportFromEPayments(): void {
    // Set loading state
    this.isLoaded = false;
    this.changeDetectionRef.detectChanges();

    // Call the backend endpoint
    this.client.importFromEPayments().subscribe({
      next: (response) => {
        // Restore loaded state
        this.isLoaded = true;

        if (response.success) {
          // Show success notification with count
          const message = response.importedCount > 0
            ? `Успешно импортирани ${response.importedCount} банкови сметки`
            : response.message || 'Няма нови банкови сметки за импортиране';

          this.toastr.success(message, "Импорт от ePayments", {
            timeOut: 3000,
            closeButton: true,
            positionClass: "toast-top-right",
          });

          // Refresh the bank accounts list
          this.LoadData();
        } else {
          // Show error message
          this.toastr.error(response.message || 'Възникна грешка при импортирането', "Грешка", {
            timeOut: 3000,
            closeButton: true,
            positionClass: "toast-top-right",
          });

          this.changeDetectionRef.detectChanges();
        }
      },
      error: (error) => {
        // Restore loaded state
        this.isLoaded = true;

        // Show error notification
        this.toastr.error("Възникна грешка при импортирането на банкови сметки", "Грешка", {
          timeOut: 3000,
          closeButton: true,
          positionClass: "toast-top-right",
        });

        this.changeDetectionRef.detectChanges();
      }
    });
  }
}

